import React from "react";

const COLORS = ["#FF3B4E", "#2ECC71", "#FFD700", "#4FC3F7", "#FFFFFF"];

export const TwinkleLights = ({ count = 40 }) => (
  <div className="relative h-8 overflow-hidden bg-candy-night" aria-hidden data-testid="twinkle-lights">
    <svg className="absolute top-0 left-0 w-full h-4" preserveAspectRatio="none" viewBox="0 0 100 10">
      <path d="M0 2 Q 2.5 8 5 2 T 10 2 T 15 2 T 20 2 T 25 2 T 30 2 T 35 2 T 40 2 T 45 2 T 50 2 T 55 2 T 60 2 T 65 2 T 70 2 T 75 2 T 80 2 T 85 2 T 90 2 T 95 2 T 100 2" fill="none" stroke="#2b2b2b" strokeWidth="0.6" />
    </svg>
    <div className="relative flex justify-between px-2 pt-2">
      {Array.from({ length: count }, (_, i) => {
        const c = COLORS[i % COLORS.length];
        return (
          <span
            key={i}
            className={`light-bulb shrink-0 ${i > 18 ? "hidden sm:block" : ""}`}
            style={{ background: c, boxShadow: `0 0 10px 3px ${c}`, animationDelay: `${(i % 5) * 0.3}s` }}
          />
        );
      })}
    </div>
  </div>
);
